export default __webpack_public_path__ + "static/media/10.1d1c4514.png";